import React from 'react';

export interface GsProgressBarProps {
  value: number;
  max: number;
  /** Affiche « value / max » à droite (ou un libellé custom). */
  label?: string | boolean;
  className?: string;
}

/**
 * Barre de progression fine standard GS (pattern mock mobile Shell V2).
 * Piste slate-200, remplissage brand-500 — la progression est un état
 * d'identité/wayfinding : canal brand légitime (verdict C 2026-06-10).
 */
export function GsProgressBar({ value, max, label, className }: GsProgressBarProps) {
  const safeMax = max > 0 ? max : 1;
  const pct = Math.min(100, Math.max(0, (value / safeMax) * 100));
  const labelText = label === true ? `${value} / ${max}` : label;
  return (
    <div className={['flex items-center gap-2', className ?? ''].join(' ').trim()}>
      <div
        className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div
          className="h-full rounded-full bg-brand-500 transition-[width] duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
      {labelText != null && labelText !== false && (
        <span className="shrink-0 text-meta font-medium tabular-nums text-slate-500 dark:text-slate-400">
          {labelText}
        </span>
      )}
    </div>
  );
}
